<template>
  <a-steps
    class="yy-steps"
    :size="size"
    :current="current"
    label-placement="vertical"
    :items="items"
    :icons="icons"
  >
  </a-steps>
</template>

<script lang="tsx" setup>
interface StepItem {
  title: string;
  description?: string;
  status?: 'wait' | 'process' | 'finish' | 'error';
}

withDefaults(
  defineProps<{
    current: number;
    items: StepItem[];
    size?: 'default' | 'small';
  }>(),
  {
    size: 'small',
  },
);

const antStepIconBg = useCssBgUrl('/youyan-platform/svg/check.svg');
</script>

<style lang="scss">
.yy-steps {
  // 完成状态的步骤项
  .ant-steps-item-finish {
    padding-left: 0 !important;

    .ant-steps-item-icon {
      background: var(--purple-6) !important;
      color: #fff;

      .ant-steps-icon {
        background: v-bind('antStepIconBg') no-repeat center;
        background-size: 75% 75%;
        width: 100%;
        height: 100%;
      }
    }

    .ant-steps-item-tail {
      top: -7px;
    }

    .ant-steps-item-description,
    .ant-steps-item-title {
      color: var(--text-1) !important;
    }

    .ant-steps-item-tail {
      &::after {
        opacity: 1;
      }
    }
  }

  // 步骤项容器
  .ant-steps-item-container {
    pointer-events: none;
  }

  // 当前激活的步骤项
  .ant-steps-item-active {
    .ant-steps-item-icon {
      position: relative;
      background: var(--back-5);
      border: 2px solid var(--purple-6);

      &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        content: '';
        display: block;
        width: 9px;
        height: 9px;
        background: var(--purple-6);
      }
    }

    .ant-steps-icon {
      display: none;
    }
  }

  // 等待状态的步骤项
  .ant-steps-item-wait {
    .ant-steps-item-icon {
      opacity: 0.3;
      position: relative;
      background: white;
      border: 2px solid var(--purple-6);
    }

    .ant-steps-icon {
      display: none;
    }
  }

  // 步骤内容区域
  .ant-steps-item-content {
    position: absolute;
    top: -40px;
    left: 45px;
    font-size: 14px;
    display: flex !important;
    align-items: center;
    gap: 5px;
    width: 200px !important;

    .ant-steps-item-title {
      font-size: 20px;
      font-weight: bold;
    }
    .ant-steps-item-description {
      white-space: nowrap;
    }
  }
}
</style>
